import React from "react"

import { queryIndex } from 'src/utils/queryIndex'
import { ProductCard } from 'src/components/product/card'
import { SEO } from 'src/components/SEO'

const IndexPage = () => {
	const data = queryIndex()
	
	return (
		<div className='container--xl outer p1 mxa'>
			<SEO />
			<div className='f jcb fw ais'>
				{data.map(({ node }: {node: any}) => (
					<ProductCard {...node._rawContent} key={node._rawContent.shopify.productId} />
				))}
				<div className='c30 x grid__product' />
				<div className='c30 x grid__product' />
			</div>
		</div>
	)
}

export default IndexPage
